import React from 'react';
import styles from './LoadingField.module.css';

const InputPlaceholder = () => <div className={styles.inputPlaceholder} />;

const LoadingField = () => {
  return (
    <div className="container-fluid p-0">
      <div className="container-fluid ps-0 pe-0 pt-2 pb-0 bg-white">
        <div className="row p-0 m-0 align-items-center">
          <InputPlaceholder />
        </div>
      </div>
    </div>
  );
};

export default LoadingField;
